<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 1C7.73 1 1 7.73 1 16s6.73 15 15 15 15-6.73 15-15S24.27 1 16 1m0 27.1a12.11 12.11 0 0 1 0-24.2 12.11 12.11 0 0 1 0 24.2m0-18.39h-2.9a1.45 1.45 0 1 0 0 2.9h1.45v8.23a1.45 1.45 0 1 0 2.9 0v-9.68c0-.8-.65-1.45-1.45-1.45"/></svg>
</template>
